export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  if (phoneNumber.length < 4) return phoneNumber;
  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const validatePhoneNumber = (phoneNumber) => {
  const numbers = phoneNumber.replace(/\D/g, '');
  return numbers.length === 10;
};

export const splitPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D/g, '');
  return {
    areaCode: cleaned.slice(0, 3),
    phoneNumber: cleaned.slice(3)
  };
}; 